import { gettext } from '@eventbrite/i18n';

export const SUSPENDED_ACCOUNT_ERROR_MESSAGE = gettext(
    'Your Account has been suspended.',
);

export const NOT_AUTHORIZED_ERROR_MESSAGE = gettext(
    'The feature that you requested is not available to you.',
);

export const PASSWORDLESS_TOKEN_EXPIRED_MESSAGE = gettext(
    'Your link has expired. Please try again and we will send you a new link.',
);

export const PASSWORDLESS_TOKEN_REUSED_MESSAGE = gettext(
    'Your link has been used. Please request a new link.',
);
